const ColumnHelper = ({
    header,
    accessorKey,
    cell = (info) => {
        const value = info.getValue();
        return value === undefined || value === null || value === "" ? "N/A" : value;
    },
    meta = {},
    ...props
}) => ({
    header,
    accessorKey,
    cell,
    meta,
    ...props
});


export default ColumnHelper;